import '../social_content.js.coffee'
Monitoring.Models.SocialContents ||= {}

# TODO: ¿seria mejor heredar de class Monitoring.Models.SocialContents.AnalysisUnit?
# Me genera dudas el flujo a partir de Monitoring.Models.SocialContents.AnalysisUnitFactory

class Monitoring.Models.SocialContents.TikTokContent extends Monitoring.Models.SocialContents.SocialContent

  type: ->
    return @get('type')

  subType: ->
    return @get('sub_type')

  created_at: ->
    return @get('created_at')

  content: ->
    return @data().text

  userId: ->
    return @data().author_id

  username: ->
    return @data().author_username

  name: ->
    return @data().author_name

  avatar: ->
    @data().avatar_url || @defaultAvatar()

  defaultAvatar: ->
    return window.image_path('default_avatars/tiktok/tiktok.png')

  userLink: ->
    return "https://tiktok.com/#{@username()}/"

  contentUrl: ->
    tiktokItemId = @data().tiktok_item_id;
    return "https://tiktok.com/@fakeuser/video/#{tiktokItemId}" if tiktokItemId

  externalId: ->
    return @get('external_id')

  getImmediateParentId: ->
    # En el comment replay podria ser el commentario al que responde
    return ''

  getSentiment: (value = false) ->
    if value
      @get('sentiment')?.value
    else
      @get('sentiment')

  setSentiment: (value) ->
    @set('sentiment', { value: value })

  isPost: ->
    return false

  isVideo: ->
    return false

  showVideoAsLink: ->
    return false

  data: ->
    return @get('data')
